import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79d603fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "dash-cyber-health-score-over-time" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-h-[16px] tw-text-base tw-font-semibold tw-w-full tw-text-[#211F58]" }
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_11857_6901)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.4157 1.5H10.0407C10.0076 1.5 9.97576 1.48683 9.95232 1.46339C9.92888 1.43995 9.91571 1.40815 9.91571 1.375V0.5C9.91571 0.367392 9.86303 0.240215 9.76926 0.146447C9.6755 0.0526784 9.54832 0 9.41571 0C9.2831 0 9.15592 0.0526784 9.06216 0.146447C8.96839 0.240215 8.91571 0.367392 8.91571 0.5V2.875C8.91571 2.97446 8.8762 3.06984 8.80588 3.14017C8.73555 3.21049 8.64017 3.25 8.54071 3.25C8.44125 3.25 8.34587 3.21049 8.27555 3.14017C8.20522 3.06984 8.16571 2.97446 8.16571 2.875V1.75C8.16571 1.6837 8.13937 1.62011 8.09249 1.57322C8.0456 1.52634 7.98201 1.5 7.91571 1.5H4.79071C4.75756 1.5 4.72576 1.48683 4.70232 1.46339C4.67888 1.43995 4.66571 1.40815 4.66571 1.375V0.5C4.66571 0.367392 4.61303 0.240215 4.51926 0.146447C4.4255 0.0526784 4.29832 0 4.16571 0C4.0331 0 3.90593 0.0526784 3.81216 0.146447C3.71839 0.240215 3.66571 0.367392 3.66571 0.5V2.875C3.66571 2.97446 3.6262 3.06984 3.55588 3.14017C3.48555 3.21049 3.39017 3.25 3.29071 3.25C3.19125 3.25 3.09587 3.21049 3.02555 3.14017C2.95522 3.06984 2.91571 2.97446 2.91571 2.875V1.75C2.91571 1.6837 2.88937 1.62011 2.84249 1.57322C2.7956 1.52634 2.73201 1.5 2.66571 1.5H1.91571C1.65049 1.5 1.39614 1.60536 1.2086 1.79289C1.02107 1.98043 0.91571 2.23478 0.91571 2.5V11C0.91571 11.2652 1.02107 11.5196 1.2086 11.7071C1.39614 11.8946 1.65049 12 1.91571 12H11.4157C11.6809 12 11.9353 11.8946 12.1228 11.7071C12.3104 11.5196 12.4157 11.2652 12.4157 11V2.5C12.4157 2.23478 12.3104 1.98043 12.1228 1.79289C11.9353 1.60536 11.6809 1.5 11.4157 1.5ZM11.1657 11H2.16571C2.09941 11 2.03582 10.9737 1.98893 10.9268C1.94205 10.8799 1.91571 10.8163 1.91571 10.75V4.75C1.91571 4.6837 1.94205 4.62011 1.98893 4.57322C2.03582 4.52634 2.09941 4.5 2.16571 4.5H11.1657C11.232 4.5 11.2956 4.52634 11.3425 4.57322C11.3894 4.62011 11.4157 4.6837 11.4157 4.75V10.75C11.4157 10.8163 11.3894 10.8799 11.3425 10.9268C11.2956 10.9737 11.232 11 11.1657 11Z",
    fill: "#211F58"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11857_6901" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "12",
      fill: "white",
      transform: "translate(0.666687)"
    })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "tw-px-[20px] tw-pt-[10px] tw-pb-[25px] tw-flex-1"
}
const _hoisted_8 = { class: "tw-text-[13px] tw-font-normal tw-text-[#878787]" }

import { getComponentUiText } from "@/utils/utilities";
import LineChart, { IChartSeries } from "../chart/lineChart.vue";
import { IApiPromise } from "@/interfaces/responseData";
import { IChecklistMetrics } from "@/interfaces/assessments/IAssessmentDetails";
import cloneDeep from "lodash/cloneDeep";
import { getMetricFromChecklistId } from "@/services/assessment";
import {
  getDataToChart,
  connectNulls,
  getMarkers,
  removeDuplicateMonthYear,
} from "@/utils/apexChart";
import { computed, onMounted, PropType, Ref, ref, watch } from "vue";
import { ApexOptions } from "apexcharts";
import { showErrorAPI } from "@/services/apiRoutes";
import { Assessment, Checklist } from "@/services/apiRoutes/routes";
import {
  convertUTCTimeToLocalTime,
  convertUTCTimeToLocalTimeAndFormat,
} from "@/utils/dateTimeUtils";
import { checklistStatusId, routers } from "@/utils/constants";
import router from "@/router";
import DummyCard from "../dashboard/dummyCard.vue";
import { handleChecklistDataReportSplit } from "@/services/sharing";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberHealthScoreOverTime',
  props: {
  isShowChart: {
    type: Boolean,
    required: false,
    default: true,
  },
  checklists: {
    type: Array as PropType<any[]>,
    required: true,
  },
  height: {
    type: Number,
    required: false,
    default: 148,
  },
  isShowDummy: {
    type: Boolean,
    required: false,
    default: false,
  },
  isShowTitle: {
    type: Boolean,
    required: false,
    default: true,
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  isRecommendPage: {
    type: Boolean,
    required: false,
    default: false,
  },
  checklistId: {
    type: [String, Number],
    required: false,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const loading = ref(props.isRecommendPage ? false : true);
const checklistHistory: Ref<any> = computed(() => {
  const data = store.getters["Sharing/getChecklistReportData"];
  return data.checklistHistory || [];
});

onMounted(async () => {
  if (!props.checklistId) {
    if (props.isShowDummy) {
      series.value = dummySeries;
      option.value = dummyOptionChart;
      loading.value = false;
    }
    return;
  }
  await getData();
});

watch(
  () => props.checklistId,
  async (newVal, oldVal) => {
    if (newVal !== oldVal && newVal) {
      getData();
    }
  },
);

watch(
  () => props.isShowDummy,
  (newVal) => {
    if (props.isShowDummy) {
      series.value = dummySeries;
      option.value = dummyOptionChart;
      loading.value = false;
    }
  },
);

const getData = async () => {
  loading.value = true;
  await handleChecklistDataReportSplit(
    Checklist.getChecklistReportDataHistory,
    props.checklistId,
    true,
  );
  if (checklistHistory.value && checklistHistory.value.length) {
    groupDataByMonth(checklistHistory.value);
  } else {
    if (props.isShowDummy) {
      series.value = dummySeries;
      option.value = dummyOptionChart;
      loading.value = false;
    }
  }
};

const linkToCreateAssessment = () => {
  const query = { param: "OpenModalAssessment" };
  router.push({ path: routers.assessCreate, query });
};

const option: Ref<ApexOptions> = ref({});
const series: Ref<IChartSeries[]> = ref([]);
const getListMetrics = async (checklists) => {
  if (!checklists || !checklists.length) {
    return [];
  }
  try {
    const promises: IApiPromise<IChecklistMetrics>[] = [];
    checklists.map((checklist) =>
      promises.push(getMetricFromChecklistId(checklist.checklistId)),
    );

    const resArray = await Promise.all(promises);
    return resArray.map((res, index) => {
      return {
        ...checklists[index],
        ...res?.data?.data,
        checklistDateCreated: convertUTCTimeToLocalTime(
          checklists[index].checklistHistoryDate
            ? checklists[index].checklistHistoryDate
            : checklists[index].checklistCreatedDate,
        ),
        checklistDate: checklists[index].checklistDateCreated,
        checklistScorePcnt: Math.round(res.data?.data.checklistScorePcnt * 100),
      };
    });
  } catch (error: any) {
    showErrorAPI(error, Assessment.getDetailFromCheckListId);
    return [];
  }
};

const groupDataByMonth = async (checklists) => {
  // Remove checklists are not in completed status
  checklists = checklists.filter(
    (checklist) =>
      checklist?.checklistStatusId === checklistStatusId.completed ||
      checklist?.checklistStatusId === checklistStatusId.inProgress,
  );
  let checklistsWithMetrics = await getListMetrics(checklists);
  checklistsWithMetrics.sort((a, b) => {
    return (
      new Date(b.checklistDate).getTime() - new Date(a.checklistDate).getTime()
    );
  });
  // Remove duplicate data by month of years
  checklistsWithMetrics = removeDuplicateMonthYear(checklistsWithMetrics, [
    "checklistDateCreated",
  ]);

  if (
    (!checklists || !checklists.length) &&
    props.isShowDummy &&
    !props.isLoading
  ) {
    series.value = dummySeries;
    option.value = dummyOptionChart;
    loading.value = false;
    return;
  }

  // get max and min checklistScorePcnt
  const maxScore = Math.max(
    ...checklistsWithMetrics.map((checklist) => checklist.checklistScorePcnt),
  );
  const minScore = Math.min(
    ...checklistsWithMetrics.map((checklist) => checklist.checklistScorePcnt),
  );
  const fiftyPercentile = (maxScore + minScore) * 0.5;

  const result = getDataToChart(
    checklistsWithMetrics,
    "checklistDateCreated",
    "checklistScorePcnt",
  );
  series.value = connectNulls(cloneDeep(result.valueArrays), true);

  const markers = getMarkers(
    cloneDeep(result.valueArrays),
    connectNulls(cloneDeep(result.valueArrays))[0].data,
    false,
    0,
    false,
    [],
  );
  option.value = {
    stroke: { width: 2.5, curve: "straight" },
    chart: { toolbar: { show: false } },
    series: connectNulls(cloneDeep(result.valueArrays), true),
    tooltip: {
      custom: ({ series, seriesIndex, dataPointIndex, w }) =>
        result.valueArrays[dataPointIndex] !== -1
          ? tooltipCustom(
              dataPointIndex,
              result.monthArr,
              result.valueArrays,
              markers,
            )
          : "",
    },
    xaxis: {
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: true,
        color: "#EFF0F1",
        strokeWidth: 2,
      },
      type: "category",
      categories: result.monthArr,
      labels: {
        style: {
          fontSize: "10px",
          fontWeight: 500,
          colors: "#878787",
        },
        formatter: (value) => {
          return result.mainTicks[value]
            ? convertUTCTimeToLocalTimeAndFormat({
                utcTime: value,
                customParseFormat: "M-YYYY",
              }).format("MMM-YY")
            : "";
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: true,
        color: "#EFF0F1",
        width: 2,
        offsetX: -4,
      },
      stepSize: 10,
      labels: {
        style: {
          fontSize: "8px",
          fontWeight: 500,
          colors: "#878787",
        },
        formatter: (value) => {
          return Number(value).toFixed(0);
        },
      },
    },
    markers: {
      size: 7,
      strokeWidth: 2.5,
      discrete: markers,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        type: "vertical",
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#01893D",
            opacity: 1,
          },
          {
            offset: fiftyPercentile,
            color: "#FFA300",
            opacity: 1,
          },
          {
            offset: 100,
            color: "#F70000",
            opacity: 1,
          },
        ],
      },
    },
    grid: {
      padding: { left: 10, right: 20, top: 0, bottom: 10 },
      borderColor: "#EFF0F1",
      strokeDashArray: 3,
    },
  };
  loading.value = false;
};
const tooltipCustom = (dataPointIndex, xAxis, yAxis, markers) => {
  return `<div
      class="apexcharts-tooltip-title"
      style="font-family: Helvetica, Arial, sans-serif; font-size: 12px"
    >
      ${
        xAxis[dataPointIndex]
          ? convertUTCTimeToLocalTimeAndFormat({
              utcTime: xAxis[dataPointIndex],
              customParseFormat: "M-YYYY",
            }).format("MMM-YYYY")
          : ""
      }
    </div>
    <div
      class="apexcharts-tooltip-series-group apexcharts-active"
      style="order: 1; display: flex"
    >
      <span
        class="apexcharts-tooltip-marker"
        style="background-color: ${markers[dataPointIndex].strokeColor}"
      ></span>
      <div
        class="apexcharts-tooltip-text"
        style="font-family: Helvetica, Arial, sans-serif; font-size: 12px"
      >
        <div class="apexcharts-tooltip-y-group">
          <span class="apexcharts-tooltip-text-y-label" >${
            yAxis[dataPointIndex] !== null
              ? getComponentUiText(
                  "app-component-assessments-question-type-2-icon-tooltip-score-1",
                ) + ": "
              : ""
          }</span
          ><span class="apexcharts-tooltip-text-y-value">${
            yAxis[dataPointIndex] === null
              ? getComponentUiText("app-dashboard-issue-chart-no-data-1")
              : yAxis[dataPointIndex]
          }</span>
        </div>
        <div class="apexcharts-tooltip-goals-group">
          <span class="apexcharts-tooltip-text-goals-label"></span
          ><span class="apexcharts-tooltip-text-goals-value"></span>
        </div>
        <div class="apexcharts-tooltip-z-group">
          <span class="apexcharts-tooltip-text-z-label"></span
          ><span class="apexcharts-tooltip-text-z-value"></span>
        </div>
      </div>
    </div>`;
};
const dummySeries = [
  {
    name: "Mock Data",
    data: [1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 95, 100],
  },
];

const dummyOptionChart: ApexOptions = {
  stroke: { width: 4, curve: "straight" },
  chart: { toolbar: { show: false } },
  series: [
    {
      name: "Mock Data",
      data: [1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 95, 100],
    },
  ],
  xaxis: {
    type: "category",
    categories: [
      "2021-01-01",
      "2021-02-01",
      "2021-03-01",
      "2021-04-01",
      "2021-05-01",
      "2021-06-01",
      "2021-07-01",
      "2021-08-01",
      "2021-09-01",
      "2021-10-01",
      "2021-11-01",
      "2021-12-01",
    ],
    labels: {
      style: {
        fontSize: "10px",
        fontWeight: 500,
        colors: "#878787",
      },
    },
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    stepSize: 10,
  },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      type: "vertical",
      inverseColors: true,
      colorStops: [
        {
          offset: 0,
          color: "#01893D",
          opacity: 1,
        },
        {
          offset: 57.5,
          color: "#FFA300",
          opacity: 1,
        },
        {
          offset: 100,
          color: "#F70000",
          opacity: 1,
        },
      ],
    },
  },
  grid: {
    padding: { left: 10, right: 20, top: 0, bottom: 10 },
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "dash-cyber-health-score-over-time-title",
      class: _normalizeClass(`tw-flex tw-justify-between tw-items-center tw-px-[20px] ${
        __props.isRecommendPage
          ? 'tw-pt-[20px] tw-pb-[10px]'
          : ' tw-py-[25px] tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1]'
      }`)
    }, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("div", _hoisted_2, [
          (!__props.isRecommendPage)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(`${__props.isRecommendPage ? '' : 'tw-ml-[8px]'}`)
          }, _toDisplayString(_unref(getComponentUiText)(
                "app-assess-recommendations-cyber-health-score-over-time-title-1",
              )), 3)
        ])
      ])
    ], 2),
    (!__props.isShowChart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
            "app-assess-recommendations-cyber-health-score-over-time-description-1",
          )), 1)
        ]))
      : (_openBlock(), _createBlock(LineChart, {
          key: 1,
          height: __props.height,
          series: series.value,
          "chart-options": option.value,
          loading: loading.value,
          "height-loading": __props.isRecommendPage ? 134 : 303
        }, null, 8, ["height", "series", "chart-options", "loading", "height-loading"])),
    (__props.isShowDummy && !loading.value)
      ? (_openBlock(), _createBlock(DummyCard, {
          key: 2,
          title: 
        _unref(getComponentUiText)(
          'app-dashboard-dummy-title-cyber-health-score-over-time-1',
        )
      ,
          "title-button": 
        _unref(getComponentUiText)('app-assessment-button-create-button-2')
      ,
          "title-class": 'tw-w-[319px]',
          "custom-class": 'tw-top-[67px]',
          "onButton:click": linkToCreateAssessment
        }, null, 8, ["title", "title-button"]))
      : _createCommentVNode("", true)
  ]))
}
}

})